/**
 * Create a 'variant' string from an array of product attributes for tracking purposes.
 * Format is:
 *
 *      'attr1Key' + ':' + 'attr1Value [ + '_' +'attr1Key' + ':' + 'attr1Value ]
 */
export function createVariantFromProductAttrs(attrs) {
  if (!attrs || !attrs.length || attrs.length === 0) {
    return undefined;
  }
  let variantBuilder = '';
  for (const attr of attrs) {
    const k = attr.key;
    const v = attr.value;
    // Ignore attributes with empty keys or values.
    if (!!k && !!v) {
      const newSection = `${k}:${v}`;
      if (variantBuilder.length === 0) {
        variantBuilder = newSection;
      } else {
        variantBuilder = `${variantBuilder}_${newSection}`;
      }
    }
  }
  return variantBuilder.length > 0 ? variantBuilder : undefined;
}
